export default __webpack_public_path__ + "static/media/December2020.5bc99f88.png";